
import { Options, Vue, prop } from "vue-class-component";
import SelectSearch from "@/app/ui/components/select-search/index.vue";
import ToggleV2 from "@/app/ui/components/toggle-v2/index.vue";
import { ManageAreaController } from "@/app/ui/controllers/ManageAreaController";
import { ListAvailableCourierApiRequest } from "@/data/payload/api/ManageAreaApiRequest";
import { debounce } from "lodash";

class Props {
  isShiftEnabled = prop<boolean>({ default: false });
  selectedCourier = prop<any>({ default: "" });
}

@Options({
  components: {
    SelectSearch,
    ToggleV2
  },
  watch: {
    isShiftEnabled(val: boolean) {
      if (val) {
        this.$emit('update:selectedCourier', "");
      }
    }
  },
  emits: ['update:isShiftEnabled', 'update:selectedCourier']
})
export default class AssignCourier extends Vue.with(Props) {
  courierOptions: any[] = [];
  isLoading = false;

  pagination = {
    page: 1,
    limit: 20,
    hasMore: true
  };

  searchQuery = "";

  created() {
    this.fetchCouriers();
  }

  async fetchCouriers(isReset = false) {
    if (this.isLoading) return;
    if (!isReset && !this.pagination.hasMore) return;

    this.isLoading = true;

    if (isReset) {
      this.pagination.page = 1;
      this.courierOptions = [];
      this.pagination.hasMore = true;
    }

    try {
      const params = new ListAvailableCourierApiRequest({
        page: this.pagination.page,
        limit: this.pagination.limit,
        q: this.searchQuery
      });

      const result = await ManageAreaController.getAvailableCourier(params);

      const formattedList = result.list.map((item: any) => ({
        ...item,
        displayName: `[${item.id}] ${item.name}`
      }));

      if (result.list.length < this.pagination.limit) {
        this.pagination.hasMore = false;
      }

      if (isReset) {
        this.courierOptions = formattedList;
      } else {
        this.courierOptions = [...this.courierOptions, ...formattedList];
      }

      this.pagination.page++;
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  onSearch = debounce((query: string) => {
    this.searchQuery = query;
    this.fetchCouriers(true);
  }, 500);

  onScroll() {
    this.fetchCouriers();
  }

  onClear() {
    this.searchQuery = "";
    this.fetchCouriers(true);
  }
}
